/* eslint-disable camelcase, prefer-destructuring */
/**
 * Convert CSS time in to
 * @param {string} time_string css time. e.g. `100ms` -> 100, `.15s` -> 150
 * @returns {number} time in milliseconds
 */
export const cssTimeToMilliseconds = (time_string) => {
  const num = parseFloat(time_string, 10);
  let unit = time_string.match(/m?s/);
  let milliseconds;

  if (unit) {
    unit = unit[0];
  }

  switch (unit) {
    case 's': // seconds
      milliseconds = num * 1000;
      break;
    case 'ms': // milliseconds
      milliseconds = num;
      break;
    default:
      milliseconds = 0;
      break;
  }

  return milliseconds;
};
/* eslint-enable camelcase, prefer-destructuring */
